// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__zZMU1","title":"styles_title__aBu98","withCenter":"styles_withCenter__3hEIR","gamesContainer":"styles_gamesContainer__If6te"};